import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import ReactSelect from 'components/theme/Select'
import { FormHelperText } from '@material-ui/core'
import { selectStage } from 'actions/tasks'
import language from 'utils/vast-languagepack'

export default connect(
	(state) => {
		const taskID = state.tasks.addOrEdit.taskID
		const task = state.tasks.tasksByID[taskID]
		const stats = task?.sms_stats || task?.email_stats
		const campaignStatus =
			state.tasks.addOrEdit.originalCampaignSelected?.campaign?.status
		const taskModalOpen = state.campaign.addOrEdit.taskModalOpen
		const disabled = Boolean(
			(taskModalOpen && taskID === 'new') ||
				stats ||
				campaignStatus === 'L' ||
				campaignStatus === 'C',
		)

		return {
			campaigns: state.data.campaign,
			campaignSelected: state.tasks.addOrEdit.campaignSelected,
			stageSelected: state.tasks.addOrEdit.stageSelected,
			disabled,
		}
	},
	(dispatch) => {
		return bindActionCreators({ selectStage }, dispatch)
	},
)(
	({
		error,
		campaigns,
		campaignSelected,
		stageSelected,
		selectStage,
		disabled,
	}) => {
		const customStyles = {
			control: (provided) => ({
				...provided,
				borderColor: error ? '#f44336' : 'rgba(0, 0, 0, 0.23)',
				borderRadius: '28px',
				padding: '9px 0',
			}),
			menu: (provided) => ({
				...provided,
				zIndex: 2,
			}),
		}

		const options =
			campaignSelected &&
			(campaignSelected.value || campaignSelected.value === 0) &&
			campaigns[campaignSelected.value] &&
			campaigns[campaignSelected.value].stages
				? campaigns[campaignSelected.value].stages.map((stage) => ({
						label: stage.name,
						key: `${stage.id}StageTaskFormSelect`,
						value: stage.id,
				  }))
				: []

		return disabled ? null : (
			<div>
				<ReactSelect
					isDisabled={disabled || !Boolean(campaignSelected)}
					styles={customStyles}
					value={stageSelected}
					onChange={(newValue) => selectStage(newValue)}
					closeMenuOnSelect={false}
					options={options}
					placeholder={language.task.add.stageSelect}
				/>
				<FormHelperText error={Boolean(error)}>{error}</FormHelperText>
			</div>
		)
	},
)
